import { debounce } from 'lodash';
import { execOnLoad } from '@general/helpers';
import './search-bar.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initSearchBar = (context) => {
  const snippetContainer = context.classList.contains('search-bar__container')
    ? context
    : context.closest('.search-bar__container');
  if (!snippetContainer) return;

  if (snippetContainer?.dataset?.predictiveEnabled == 'false') return;

  const form = snippetContainer.querySelector('.search-bar__form');
  if (!form) return;

  const queryField = form.querySelector('input[name="q"]');
  const categoriesWrapper = snippetContainer.querySelector('.search-bar__results-categories');
  const resultsWrapper = snippetContainer.querySelector('.search-bar__results');
  if (!queryField || !categoriesWrapper || !resultsWrapper) return;

  const cachedResults = [];

  const populateResults = (results, key) => {
    const typeWrapper = snippetContainer.querySelector(`[data-type="${key}"]`);
    if (!typeWrapper) return;

    const template = typeWrapper.querySelector('[data-template]');
    const resultsList = typeWrapper.querySelector('.search-bar__results-list');
    if (!template || !resultsList) return;

    resultsList.querySelectorAll('.search-bar__results-element:not([data-template])').forEach((el) => el.remove());
    results.map((result) => {
      const element = template.cloneNode(true);
      element.removeAttribute('data-template');

      const title = element.querySelector('.search-bar__results-element-title');
      if (title) {
        if (key == 'query') {
          if (result.styled_text) title.innerHTML = result.styled_text;
        } else {
          if (result.title) title.innerText = result.title;
        }
      }

      const link = element.querySelector('a');
      if (link && result.url) {
        link.href = result.url;
        if (key == 'query') {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            queryField.value = result.text;
            fetchSuggestions();
          });
        }
      }

      const imageWrapper = element.querySelector('.search-bar__results-element-image');
      const imageObj = result.image ?? result.featured_image;
      if (imageObj) {
        const src = typeof imageObj === 'string' ? imageObj : imageObj.src;
        if (imageWrapper) {
          if (src) imageWrapper.querySelector('img').src = src;
          else imageWrapper.remove();
        }
      } else {
        if (imageWrapper) imageWrapper.remove();
      }

      resultsList.appendChild(element);
    });
    typeWrapper.style.display = results.length > 0 ? 'block' : 'none';
  };

  const handleData = (data) => {
    if (!data?.resources?.results) return;
    const { articles = [], collections = [], pages = [], products = [], queries = [] } = data.resources.results;

    if (articles.length <= 0 && collections.length <= 0 && pages.length <= 0 && queries.length <= 0) {
      if (products.length > 0) {
        resultsWrapper.style.display = '';
        categoriesWrapper.style.display = 'none';
      } else {
        resultsWrapper.style.display = 'none';
      }
    } else {
      resultsWrapper.style.display = '';
      categoriesWrapper.style.display = '';
    }
    populateResults(articles, 'article');
    populateResults(collections, 'collection');
    populateResults(pages, 'page');
    populateResults(queries, 'query');
    populateResults(products, 'product');
  };

  const fetchSuggestions = debounce(() => {
    const params = new URLSearchParams(new FormData(form));
    if (!params.get('q')) {
      resultsWrapper.style.display = 'none';
      return;
    }
    form.classList.add('loading');

    const cachedResult = cachedResults.find((cachedResult) => cachedResult.query === params.get('q'));
    if (cachedResult) {
      handleData(cachedResult.data);
    } else {
      fetch(`${window.Shopify.routes.root}search/suggest.json?${params.toString()}`)
        .then((res) => res.json())
        .then((data) => {
          handleData(data);
          cachedResults.push({
            query: params.get('q'),
            data,
          });
        })
        .catch((err) => {
          console.error(err);
        });
    }

    form.classList.remove('loading');
  }, 500);

  form.addEventListener('input', () => {
    fetchSuggestions();
  });
};

execOnLoad(window.dAgency.initSearchBar, '.search-bar__container');
